// API Configuration
// Backend URL for bridge operations, stats, admin functions, etc.
// For local development: http://localhost:8000
// For production: https://bapes-bridge-production.up.railway.app

// Get BACKEND_URL with proper validation
function getBackendUrl() {
  const envUrl = import.meta.env.VITE_BACKEND_URL;
  const defaultUrl = 'https://bapes-bridge-production.up.railway.app';

  // Handle undefined, empty string, or placeholder values
  if (!envUrl || envUrl === '' || envUrl === 'undefined' || envUrl.includes('<')) {
    console.warn('[API Config] VITE_BACKEND_URL is not properly configured');
    console.warn('[API Config] For production deployments, set VITE_BACKEND_URL in your hosting platform');
    return defaultUrl;
  }

  // Only log backend URL in development
  if (import.meta.env.DEV) {
    console.log('[API Config] Backend URL:', envUrl);
  }
  return envUrl;
}

export const BACKEND_URL = getBackendUrl();
export const BACKEND_API = BACKEND_URL;

// Validate URL format
if (!BACKEND_URL.startsWith('http://') && !BACKEND_URL.startsWith('https://')) {
  console.error('[API Config] ERROR: Invalid BACKEND_URL format:', BACKEND_URL);
  console.error('[API Config] URL must start with http:// or https://');
  throw new Error('Invalid BACKEND_URL configuration');
}
